import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './pages/login/service/auth.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { NotificationsComponent } from './shared/components/notifications/notifications.component';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet, 
    ButtonModule, 
    RouterModule, 
    NotificationsComponent, 
    CommonModule, 
    SidebarComponent, 
  ],
  providers: [],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'ciberlens-front';
  isAuthenticated = false;
  private authSubscription!: Subscription; // Guardamos la suscripción

  isSidebarHidden = false;

  constructor(private translate: TranslateService, public authService: AuthService) {
    this.translate.addLangs(['en']);
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }


  ngOnInit() {
    // Nos suscribimos a los cambios en el usuario
    this.authSubscription = this.authService.currentUser.subscribe(user => {
      this.isAuthenticated = !!user;
    });
  }

  ngOnDestroy() {
    // Evitamos fugas de memoria
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  // Método para alternar el estado del sidebar
  onSidebarToggle(event: boolean) {
    this.isSidebarHidden = event;
  }
}
